import { render } from "./ImpressaoRequisicao.vue?vue&type=template&id=c155c4fe&scoped=true"
import script from "./ImpressaoRequisicao.vue?vue&type=script&lang=js"
export * from "./ImpressaoRequisicao.vue?vue&type=script&lang=js"

import "./ImpressaoRequisicao.vue?vue&type=style&index=0&id=c155c4fe&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c155c4fe"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTable,QTr,QTh,QTd});
